export const ACTIVITY_LOGS_QUERY_KEY = ["activity-logs"];
